import React from "react"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const DepartmentMembershipDestroyed = ({ audit }) => {
  const { nameInSentence: departmentNameInSentence } = useCustomName(DEPARTMENT_KEY)

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> removed member <span className="font-semibold">{audit.departmentMember.fullName} </span>
        from {departmentNameInSentence} <span className="font-semibold">{audit.department.name}</span>
      </span>
    </div>
  )
}

DepartmentMembershipDestroyed.propTypes = {
  audit: auditShape.isRequired,
}

export default DepartmentMembershipDestroyed
